import map from 'lodash/map'
import orderBy from 'lodash/orderBy'
import React, { FC } from 'react'

import { ImageOptions } from '@Components/Cloudinary/Image'
import { imageSrcSet } from '@Globals/Cloudinary'

export interface Source extends Omit<ImageOptions, 'path'> {
  minWidth: number
  path?: string
}

interface PictureProps {
  alt?: string
  className?: string
  options: ImageOptions
  sources?: Source[]
}

export const Picture: FC<PictureProps> = (
  {
    alt = '',
    options,
    sources = [],
    className,
  }: PictureProps,
) => {
  const sortedSources = orderBy(sources, s => s.minWidth, 'desc')
  return (
    <picture className={className}>
      {map(sortedSources, (source: Source) => {
        const { path, ...sourceOptions }: ImageOptions = {
          ...options,
          ...source,
        }

        return (
          <source
            key={source.minWidth}
            media={`(min-width: ${source.minWidth}px)`}
            srcSet={imageSrcSet(path, sourceOptions)}
          />
        )
      })}
      <img
        key="default"
        alt={alt}
        srcSet={imageSrcSet(
          options.path,
          options,
        )}
      />
    </picture>
  )
}
